var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DatePickerLib,_vm._g(_vm._b({},'DatePickerLib',{ ..._vm.$attrs, value: _vm.value },false),_setup.instance.proxy.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }